import { Injectable } from '@angular/core';
import { stonlyTrackFn } from '../utils/stonly-custom-properties/stonlyCustomProperties';
import '../utils/stonly-custom-properties/stonlyCustomProperties';

@Injectable({
  providedIn: 'root',
})
export class StonlyService {
  stonlyTrackFn(userId: string, customPropObj: unknown) {
    stonlyTrackFn(userId, customPropObj);
  }
}
